export default __webpack_public_path__ + "static/media/5.9d2307e4.jpg";